import { inject } from '@angular/core';
import { MiscUtil } from '../util/misc.util';
import { BooktechAppService } from './booktech-app.service';
// import { FADE_CLASS_NAME_MAP } from 'ng-zorro-antd/image';


export class AppCommonService {


  constructor(public bas: BooktechAppService ) {
    if (this.bas.envtest) console.log("AppCommonService.constructor");

   
  }


  productGet(id:number|string, extraParams:any = { }):Promise<any> {
    let params = {
      aType: "order", 
      action: "getProduct", 
      id: id
    }
    MiscUtil.extend(params, extraParams || { });

    return this.bas.ws.json(params).then((json) => {
      // if (this.bas.envtest) console.log("getProduct, json: ", json);
      if (json.success) {
        let p = json.product;
        this.updateProductObj(p);
        // return p;
      }
      return json;

    });
  }

  // products start
  productsGrid = { 
    xs: 24, 
    sm: 12, 
    md: 8, 
    lg: 8, 
    xl: 6,  
    xxl: 6,  
    gutter: [8, 16] as [number, number]
  };
  
  updateProductObj(p:any, opts?:any) {
    opts = opts || { };
    let qps = opts.qps || { };
    let lang = opts.lang || this.bas.ds.findLang() || "no";
    if (p.url) p.urlFull = this.bas.ws.getBaseUrl(p.cid) + p.url + "?source=" +(qps.source || this.bas.settings.appId);

    let ctx = opts.ctx || { };

    let isAdmin = this.bas.aas.isAdmin();

    let updateRoute = true;
    // let useCbsite = this.bas.settings.appId == 'cbsite';
    // if (opts.useCbsite !== undefined) useCbsite = opts.useCbsite;
    let useCbsite = true;
    let useCbsiteWidget = opts.useCbsiteWidget !== undefined ? opts.useCbsiteWidget : false;

    let fc:any = undefined;
    let isCbsite = this.bas.settings.appId == 'cbsite';
    if (!isCbsite) {
      fc = this.bas.ds.findCompany();
      if (fc && fc.useCbsite === true) {
        useCbsite = true;
      }

      useCbsiteWidget = opts.useCbsiteWidget !== undefined ? opts.useCbsiteWidget : fc?.useCbsiteWidget;
    }


    if (opts.checkCbsiteEnable) {
      fc = this.bas.ds.config.appConfig?.companies?.[p.cid];
      if (this.bas.envdev) console.log("updateProductObj, fc: "+ fc?.username + ", upCbCbsiteEnabled: " +  (fc && fc.upCbCbsiteEnabled) );
      if (fc && fc.upCbCbsiteEnabled === false) {
        updateRoute = false;
        useCbsite = false;
      } else {
        
      }
  
      if (this.bas.envdev) updateRoute = true; // TODO
    }

    if ( updateRoute) {
     
      let typeName = p.findType  || p.typeObj?.mkName;
      let pName = p.mkName || p.name;

      let pInfo:any = "" + p.findSubType; // SubType og area   :  Property 'replaceAll' does not exist on type 'string'. Do you need to change your target library? Try changing the 'lib' compiler option to 'es2021' or later.
      if (p.findArea) pInfo += (pInfo ? " " : "") + p.findArea;
      if (!pInfo) pInfo = p.findType || p.typeObj.mkName;

      typeName = this.bas.us.urlSegment(typeName);
      pInfo = this.bas.us.urlSegment(pInfo);
      pName = this.bas.us.urlSegment(pName);

      let cbsiteHostname = (this.bas.envtest ? fc?.findCbSiteHostnameTest : fc?.findCbSiteHostname);

      // TODO: hvis link fra cloudbooking.io, så skal vi linke til 
      if ((opts.isRoot && this.bas.envprod) || this.bas.ui.isCustomHostname(cbsiteHostname) ) { // || (!isCbsite &&  useCbsite)
        p.cbsiteRoute = [ 
          "/" + lang
        ];
      } else {
        p.cbsiteRoute = [ 
          "/booking",
          p.cid,
          lang
        ];
      }
      p.cbsiteRoute = [
        ...p.cbsiteRoute, 
        "p",
        typeName,
        pInfo,
        pName + "-" + p.id
      ]

      p.cbsiteHref = p.cbsiteRoute.join("/");

   
      p.findUrlFull = p.urlFull;

      if (useCbsiteWidget && p.externalUrl) {
        p.findUrlFull = p.externalUrl;
      }
      else if (useCbsite) {
        p.findUrlFull = "https://" +  cbsiteHostname + p.cbsiteHref;
        
        p.cbsiteDebugFc = fc?.username;
        p.cbsiteDebug = "site: " + fc?.findCbSiteHostname + ", cbsiteHref: " + p.cbsiteHref;
        if (opts.isRoot && this.bas.envprod) {
          p.cbsiteHref =  p.findUrlFull;
        }
        // if (this.bas.envdev) console.log("updateProductObj, hostname: " + fc?.findCbSiteHostnameTest + ", cbsiteHref: " + p.cbsiteHref);
     
      }

    

   

      
    }
  
    let imageList:any[] = [];
    for (let iid of p.images || []) {
      imageList.push(p.imageMap[iid]);
    }
    p.imageList = imageList;
    p.imageMap = undefined;
  

    if (p.pcCollection) {
      p.hideOrderForm = true;
    

    }
    for (let cp of p.collectionRelations || [] ) this.updateProductObj(cp, opts);

    if (p.typePackage ) { 
      p.hideOrderForm = true;      
      p.hideImages = true;
      p.customProductView = "order-form-package";
    }

    if (!isAdmin) {

      if (p.daysDropdownMax) {
      
        p.findMinRange = p.daysDropdownMin;
        p.findMaxRange = p.daysDropdownMax;
        if (p.isStartBeforeEnd === false) {
          p.findMinRange++;
          p.findMaxRange++;
        }
      } else if (p.findTypeLodging) {
        p.findMinRange = p.findMinDays + 1; //TODO: Hva med adminj
        // p.findMaxRange = p.daysDropdownMax;
      }
      
    }
 

    

    let pc = p.productConfigObj;
    if (pc) {
      if (pc.isCbWidget) {
        switch (p.cbWidgetPath) {
          case "/order/form/kjerringtorget": 
            p.hideOrderForm = true;
            p.customProductView = "order-form-kjerringtorget";
            break;
        }
      } else if (pc.isRoute) {
        p.hideOrderForm = true;
        p.customProductView = "order-form-route";
        // p.customCartAddView = "order-form-route";
        
      }
    }




  }

  updateProductListObj(p:any, opts?:any) {
    opts = opts || { };
    let lang = opts.lang || this.bas.ds.findLang() || "no";

    let cid = p.cid;

    p.findTypeLodging = p.findTypePtid === "g_lodging_lodging";

    if (p.images && p.images.length) {
      let first = p.images[0];
      if (first && first.id && first.ext) {
        let imageCid = first.cid || cid;
        let base = this.bas.ws.getBaseUrlPf() + "/pf/img/product/" + imageCid + "/" + first.id + "/";
        p.firstImageUrlOrg = base + first.id + "-org." + first.ext;
        p.firstImageUrlLarge = first.hasLarge !== false
          ? base + first.id + "-1024x768." + first.ext
          : p.firstImageUrlOrg;
        p.firstImageUrlMedium = first.hasMedium !== false
          ? base + first.id + "-400x300." + first.ext
          : p.firstImageUrlOrg;
      }
    }

    let typeName = p.findType || "";
    let pInfo:any = "" + (p.findSubType || "");
    if (p.findArea) pInfo += (pInfo ? " " : "") + p.findArea;
    if (!pInfo) pInfo = p.findType || "";

    let pName = (p.mkName || p.name || "");

    typeName = this.bas.us.urlSegment(typeName);
    pInfo = this.bas.us.urlSegment(pInfo);
    pName = this.bas.us.urlSegment(pName);

    let fc:any = undefined;
    if (opts.checkCbsiteEnable) {
      fc = this.bas.ds.config.appConfig?.companies?.[cid];
    }
    let cbsiteHostname = (this.bas.envtest ? fc?.findCbSiteHostnameTest : fc?.findCbSiteHostname);

    let updateRoute = true;
    if (opts.checkCbsiteEnable) {
      if (fc && fc.upCbCbsiteEnabled === false) {
        updateRoute = false;
      } else {
        updateRoute = true;
      }
      if (this.bas.envdev) updateRoute = true;
    }

    if (updateRoute) {
      if ((opts.isRoot && this.bas.envprod) || this.bas.ui.isCustomHostname(cbsiteHostname)) {
        p.cbsiteRoute = [ "/" + lang ];
      } else {
        p.cbsiteRoute = [ "/booking", cid, lang ];
      }
      p.cbsiteRoute = [
        ...p.cbsiteRoute, 
        "p",
        typeName,
        pInfo,
        pName + "-" + p.id
      ];

      p.cbsiteHref = p.cbsiteRoute.join("/");

      if (cbsiteHostname) {
        p.findUrlFull = "https://" + cbsiteHostname + p.cbsiteHref;
        if (opts.isRoot && this.bas.envprod) {
          p.cbsiteHref = p.findUrlFull;
        }
      }
    }
  }

  productsGet(ctx:any, extraParams:any = { }):Promise<any> {
    let params = {
      aType: "order", 
      action: "getProducts", 
    }

    if (this.bas.envtest) console.log("productsGet.ctx: ", ctx);

    let qps = ctx.queryParams || { };

    MiscUtil.extend(params, qps);
    MiscUtil.extend(params, extraParams || { });

    let lang = this.bas.ds.findLang() || "no";
    // let cid = this.bas.ds.findCid();


    return this.bas.ws.json(params).then((json) => {
      // if (this.bas.envtest) console.log("getProducts, json: ", json);
      if (json.success) {
        ctx.productTypes = json.productTypes || { };
        if (ctx.type === undefined) ctx.type = json.type || (ctx.productTypes ? ctx.productTypes[0].id : undefined);
        for (let p of  json.products || []) {
         this.updateProductObj(p, { lang,  qps, ctx });
        }
        ctx.products = json.products || [];

        

        for (let ptid of Object.keys(json.productsMap || { })) {
          for (let p of  json.productsMap[ptid] || []) {
            this.updateProductObj(p, { lang,  qps, ctx });
            // p.urlFull = this.bas.ws.getBaseUrl(p.cid) + p.url + "?source=" +(qps.source || "cbapi5");

          }
        }


        ctx.productsMap = json.productsMap || { };

      
        
      }

      return json;
    });
  }

  productsOnClick(event:any, ctx:any, p:any) {
    if (ctx.queryParams?.newWindow == "true") {
      return;
    }


    event.preventDefault();
    if (this.bas.envtest) console.log("productClick: ", p);

    this.bas.es.sendParentMessageRedir(p.findUrlFull || p.urlFull);
  }

  // products end

  


}
